import { gql } from '@apollo/client';

const ELECTROPHYSIOLOGIST_EVENT_QUERY = gql`
  query event($id: ID!) {
    event(id: $id) {
      id
      friendlyId
      type
      isValid
      start
      study {
        id
        start
        facility {
          contact {
            country
          }
          timezone
        }
        timezone
        status
        studyTimeOffset
      }
      eventSetting {
        postEventTime
        diagnosticLead
      }
      reportData {
        channels
        samplingFrequency
        gain
        dataPath
        firstSample
        eventPos
        fullData {
          dataPath
          minutelyHrs
          duration
          maxHr
          minHr
        }
        aiPredict {
          channel
          hesBeatStatus
          beats
        }
      }
      hrInfo
    }
  }
`;

export default ELECTROPHYSIOLOGIST_EVENT_QUERY;
